import PropTypes from 'prop-types'

import { Checkbox, CheckboxControl } from '@redriverpress/system'

import Field from './Field'

/**
 * Wrapper around field to avoid repeat a lot of properties when
 * we show a checkbox on a form
 */
export default function CheckboxField({ label, ...props }) {
  const component = label ? Checkbox : CheckboxControl
  return <Field as={component} type='checkbox' label={label} {...props} />
}

CheckboxField.defaultProps = {
  label: null,
}

CheckboxField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}
